import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class A11yKeyboardService {
  public isActivationKey(event: KeyboardEvent): boolean {
    return event.key === 'Enter' || event.key === ' ';
  }

  public activateOnEnterOrSpace(event: KeyboardEvent, action: () => void): void {
    if (!this.isActivationKey(event)) {
      return;
    }

    event.preventDefault();
    action();
  }

  public focusNext(items: HTMLElement[], currentIndex: number): void {
    if (!items.length) {
      return;
    }

    items[(currentIndex + 1) % items.length].focus();
  }

  public focusPrevious(items: HTMLElement[], currentIndex: number): void {
    if (!items.length) {
      return;
    }

    items[(currentIndex - 1 + items.length) % items.length].focus();
  }
}
